import React from 'react';

import colors from 'styles/theme/colors';

const MenuHorizontalIcon = ({ color = colors.black75, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='12px' height='12px' viewBox='0 0 12 12' {...props}>
    <g transform='translate(0, 0)'>
      <circle cx='6' cy='6' r='1.5' fill={color} data-color='color-2'></circle>
      <circle cx='10.5' cy='6' r='1.5' fill={color}></circle>
      <circle cx='1.5' cy='6' r='1.5' fill={color}></circle>
    </g>
  </svg>
);

export default MenuHorizontalIcon;
